import { IconTypes } from "../Icons";

export default function Store({
  color = "#ffffff",
  fontSize = "1.6rem",
  rotate = 0,
  className = "",
}: IconTypes) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      style={{
        width: "1em",
        height: "1em",
        fontSize,
        transform: `rotate(${rotate}deg)`,
      }}
      className={className}
    >
      <path
        d="M11.0253 17.0625H6.97531C3.27031 17.0625 1.69531 15.48 1.69531 11.7825V8.41498C1.69531 8.10748 1.95031 7.85248 2.25781 7.85248C2.56531 7.85248 2.82031 8.10748 2.82031 8.41498V11.7825C2.82031 14.85 3.90781 15.9375 6.97531 15.9375H11.0178C14.0853 15.9375 15.1728 14.85 15.1728 11.7825V8.41498C15.1728 8.10748 15.4278 7.85248 15.7353 7.85248C16.0428 7.85248 16.2978 8.10748 16.2978 8.41498V11.7825C16.3053 15.48 14.7228 17.0625 11.0253 17.0625Z"
        fill="white"
      />
      <path
        d="M9.00025 9.5625C8.17525 9.5625 7.42524 9.24 6.89274 8.6475C6.36024 8.055 6.11275 7.2825 6.19525 6.4575L6.69775 1.4475C6.72775 1.1625 6.96775 0.9375 7.26025 0.9375H10.7627C11.0552 0.9375 11.2952 1.155 11.3252 1.4475L11.8277 6.4575C11.9102 7.2825 11.6627 8.055 11.1302 8.6475C10.5752 9.24 9.82525 9.5625 9.00025 9.5625ZM7.76275 2.0625L7.31275 6.57C7.26025 7.0725 7.41025 7.545 7.72525 7.89C8.36275 8.595 9.63775 8.595 10.2752 7.89C10.5902 7.5375 10.7402 7.065 10.6877 6.57L10.2377 2.0625H7.76275Z"
        fill="white"
      />
      <path
        d="M13.733 9.5625C12.2105 9.5625 10.853 8.3325 10.6955 6.8175L10.1705 1.56C10.1555 1.4025 10.208 1.245 10.313 1.125C10.418 1.005 10.568 0.9375 10.733 0.9375H13.0205C15.2255 0.9375 16.253 1.86 16.5605 4.125L16.7705 6.21C16.8605 7.095 16.5905 7.935 16.013 8.5725C15.4355 9.21 14.6255 9.5625 13.733 9.5625ZM11.3555 2.0625L11.8205 6.705C11.918 7.6425 12.788 8.4375 13.733 8.4375C14.303 8.4375 14.813 8.22 15.1805 7.8225C15.5405 7.425 15.7055 6.8925 15.653 6.3225L15.443 4.26C15.2105 2.565 14.663 2.0625 13.0205 2.0625H11.3555Z"
        fill="white"
      />
      <path
        d="M4.23026 9.5625C3.33776 9.5625 2.52776 9.21 1.95026 8.5725C1.37276 7.935 1.10276 7.095 1.19276 6.21L1.39526 4.1475C1.71026 1.86 2.73776 0.9375 4.94276 0.9375H7.23026C7.38776 0.9375 7.53776 1.005 7.65026 1.125C7.76276 1.245 7.80776 1.4025 7.79276 1.56L7.26776 6.8175C7.11026 8.3325 5.75276 9.5625 4.23026 9.5625ZM4.94276 2.0625C3.30026 2.0625 2.75276 2.5575 2.51276 4.275L2.31026 6.3225C2.25026 6.8925 2.42276 7.425 2.78276 7.8225C3.14276 8.22 3.65276 8.4375 4.23026 8.4375C5.17526 8.4375 6.05276 7.6425 6.14276 6.705L6.60776 2.0625H4.94276Z"
        fill="white"
      />
      <path
        d="M10.875 17.0625H7.125C6.8175 17.0625 6.5625 16.8075 6.5625 16.5V14.625C6.5625 13.05 7.425 12.1875 9 12.1875C10.575 12.1875 11.4375 13.05 11.4375 14.625V16.5C11.4375 16.8075 11.1825 17.0625 10.875 17.0625ZM7.6875 15.9375H10.3125V14.625C10.3125 13.68 9.945 13.3125 9 13.3125C8.055 13.3125 7.6875 13.68 7.6875 14.625V15.9375Z"
        fill="white"
      />
    </svg>
  );
}
